import * as Events from '@core/events';

export const handler = ({
  field,
}: Pick<Events.TEventInformation<unknown>, 'field' | 'eventReducedSchema'>) => {
  field.data.blured = true;
};
